<div class="task-mgmt-wf-container">

  <!-- ========== TOOLBAR ========== -->
  <div class="tmwf-toolbar">

    <div class="tmwf-toolbar-left">
      <!-- Search bar + Filter icon -->
      <div class="tmwf-grid-toolbar">
        <div class="tmwf-search-wrapper">
          <span class="tmwf-search-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                stroke="#1363DF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M17.5 17.5L13.875 13.875" stroke="#1363DF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <input type="text" placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onGridSearchChange()" />
        </div>
      </div>
    </div>

    <div class="tmwf-toolbar-right">

      <!-- Brand Dropdown — hidden when the board is embedded in the sidebar -->
      <div class="tmwf-brand-dropdown-wrapper" *ngIf="!sidebarMode">
        <button class="tmwf-brand-dropdown-btn" [class.open]="brandDropdownOpen" (click)="toggleBrandDropdown($event)">
          <!-- <mat-icon class="tmwf-brand-btn-icon">local_offer</mat-icon> -->
          <span class="tmwf-brand-btn-label">{{ selectedBrand?.brand_name || 'Select Brand' }}</span>
          <mat-icon class="tmwf-brand-btn-arrow">{{ brandDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <div class="tmwf-brand-dropdown-panel" *ngIf="brandDropdownOpen" (click)="$event.stopPropagation()">
          <!-- Search box -->
          <div class="tmwf-brand-search-wrap">
            <input class="tmwf-brand-search-input" type="text" placeholder="Search..." autocomplete="off"
              [ngModel]="brandSearchText" (ngModelChange)="onBrandSearch($event)" />
          </div>

          <!-- Loading state -->
          <div *ngIf="isLoadingBrands" class="tmwf-brand-loading">
            <mat-spinner diameter="16"></mat-spinner>
            <span>Loading...</span>
          </div>

          <!-- Brand list -->
          <div class="tmwf-brand-list" *ngIf="!isLoadingBrands">
            <div *ngIf="filteredBrands.length === 0" class="tmwf-brand-empty">No brands found</div>
            <div *ngFor="let brand of filteredBrands" class="tmwf-brand-item"
              [class.selected]="selectedBrand?.brand_key === brand.brand_key" (click)="selectBrand(brand)">
              <div class="tmwf-brand-checkbox" [class.checked]="selectedBrand?.brand_key === brand.brand_key">
                <mat-icon *ngIf="selectedBrand?.brand_key === brand.brand_key"
                  class="tmwf-brand-check-icon">check</mat-icon>
              </div>
              <span class="tmwf-brand-item-name">{{ brand.brand_name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- View Dropdown: Kanban Board / Tasks Table -->
      <div class="tmwf-view-dropdown-wrapper">
        <button class="tmwf-view-dropdown-btn" [class.open]="viewDropdownOpen" (click)="toggleViewDropdown($event)">
          <span class="tmwf-view-label-prefix">View:</span>
          <span>{{ currentViewMode === 'kanban' ? 'Board' : 'Table' }}</span>
          <mat-icon>expand_more</mat-icon>
        </button>
        <div class="tmwf-view-dropdown-panel" *ngIf="viewDropdownOpen">
          <button class="tmwf-view-dropdown-option" [class.active]="currentViewMode === 'kanban'"
            (click)="selectViewMode('kanban')">Board</button>
          <button class="tmwf-view-dropdown-option" [class.active]="currentViewMode === 'table'"
            (click)="selectViewMode('table')">Table</button>
        </div>
      </div>

      <!-- Create a Case / Create Child Case -->
      <button class="tmwf-create-btn" [disabled]="!isStartupComplete"
        (click)="expandedTask ? onCreateSubtaskForParent(expandedTask) : onCreateTaskClick()">
        {{ expandedTask ? 'Create Child Case' : 'Create Case' }}
      </button>
    </div>
  </div>

  <!-- ========== STARTUP LOADING OVERLAY ==========
       Shown while the startup forkJoin (lookups + tasks + subtasks) is in
       flight. Reuses the shared <loading> component exported by ChartsModule
       (which DirectModule already imports). On error the loader disappears
       and the empty board is revealed — the snackbar surfaces the failure. -->
  <div class="tmwf-board-loading-wrap" *ngIf="isLoadingTasks">
    <loading></loading>
  </div>

  <!-- ========== KANBAN BOARD VIEW ========== -->
  <div class="tmwf-kanban-board" *ngIf="!isLoadingTasks && currentViewMode === 'kanban'">
    <div class="tmwf-kanban-column" *ngFor="let column of kanbanColumns">

      <!-- Column header -->
      <div class="tmwf-kanban-column-header">
        <div class="d-flex align-items-center gap-2">
          <span class="tmwf-kanban-column-dot" [style.background]="column.color"></span>
          <span class="tmwf-kanban-column-label">{{ column.label }}</span>
        </div>
        <span>
          <span class="tmwf-kanban-column-count">{{ column.tasks.length }}</span>
          <button mat-icon-button class="tmwf-kanban-column-add" matTooltip="Create a case"
            [disabled]="!isStartupComplete" (click)="onCreateTaskInColumn(column.id); $event.stopPropagation()">
            <mat-icon>add</mat-icon>
          </button>
        </span>
      </div>

      <!-- Droppable area -->
      <div class="tmwf-kanban-column-body" cdkDropList [id]="column.id" [cdkDropListData]="column.tasks"
        [cdkDropListConnectedTo]="connectedLists" (cdkDropListDropped)="onTaskDrop($event)">

        <!-- Case card -->
        <div class="tmwf-kanban-card" *ngFor="let task of column.tasks" cdkDrag [cdkDragData]="task"
          (click)="onKanbanCardClick(task)">

          <!-- 1. Case name + header actions (subtask indicator + edit button) -->
          <div class="tmwf-kanban-card-header">
            <span class="tmwf-kanban-card-name">{{ task.taskName }}</span>
            <span class="tmwf-kanban-card-header-actions">
              <span class="tmwf-kanban-subtask-indicator" *ngIf="(task._subCount || 0) > 0"
                [matTooltip]="getSubtaskTooltip(task)">
                <mat-icon class="tmwf-subtask-icon">account_tree</mat-icon>
              </span>
              <!-- Edit pencil — hidden by default, revealed on card hover via CSS.
                   stopPropagation prevents the parent card click from also opening
                   the subtask sidebar. Opens the dialog on the Details tab (0). -->
              <button type="button" class="tmwf-card-edit-btn" (click)="onEditTask(task, 0); $event.stopPropagation()"
                matTooltip="Edit case">
                <mat-icon class="tmwf-card-edit-icon">edit</mat-icon>
              </button>
            </span>
          </div>

          <!-- 2. Description (max 2 lines) -->
          <div class="tmwf-kanban-card-desc" *ngIf="task.description">{{ task.description }}</div>

          <div class="d-flex justify-content-between">
            <!-- Stacked assignee avatars -->
            <div class="tmwf-kanban-card-footer" *ngIf="getAssignees(task).length > 0">
              <div class="tmwf-card-avatars">
                <div class="tmwf-avatar-circle" *ngFor="let email of getAssignees(task).slice(0, 3)"
                  [matTooltip]="email">
                  {{ getInitials(email) }}
                </div>
                <div class="tmwf-avatar-circle tmwf-avatar-more" *ngIf="getAssignees(task).length > 3">
                  +{{ getAssignees(task).length - 3 }}
                </div>
              </div>
            </div>

            <!-- 3. Priority chip + Case Type chip -->
            <div class="tmwf-kanban-card-chips">
              <span class="tmwf-priority-chip" [ngClass]="getPriorityClass(task)" *ngIf="getPriorityName(task)">
                {{ getPriorityName(task) }}
              </span>
              <span class="tmwf-type-chip" *ngIf="getTaskTypeName(task)">
                {{ getTaskTypeName(task) }}
              </span>
            </div>
          </div>
          <!-- 4. Due date row + comment/attachment shortcuts.
               The row renders if the task has a due date OR a comment count
               OR any attachments. Both shortcut buttons open the dialog on
               the corresponding tab (1=Updates, 2=Attachments) via the
               existing `initialTab` data prop wired in TaskDetailContentComponent. -->
          <div class="tmwf-card-due-row"
            *ngIf="task.endDate || getCommentCount(task) > 0 || getAttachmentCount(task) > 0">
            <span class="tmwf-card-due" *ngIf="task.endDate" [class.overdue]="isOverdue(task)">
              Due {{ formatDueDate(task.endDate) }}<span *ngIf="isOverdue(task)"> · Overdue</span>
            </span>
            <span class="tmwf-card-due-spacer"></span>
            <!-- Attachment shortcut -->
            <button type="button" class="tmwf-card-attach-btn" (click)="onEditTask(task, 2); $event.stopPropagation()"
              matTooltip="Attachments">
              <mat-icon class="tmwf-card-attach-icon">attach_file</mat-icon>
              <span class="tmwf-card-attach-count" *ngIf="getAttachmentCount(task) > 0">
                {{ getAttachmentCount(task) }}
              </span>
            </button>
            <!-- Comment shortcut -->
            <button type="button" class="tmwf-card-comment-btn" (click)="onEditTask(task, 1); $event.stopPropagation()"
              matTooltip="Comments">
              <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"
                style="vertical-align:middle">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
              <span class="tmwf-card-comment-count" *ngIf="getCommentCount(task) > 0">
                {{ getCommentCount(task) }}
              </span>
            </button>
          </div>



          <!-- 5. Divider + 6. Child Case progress bar (only when there are subtasks) -->
          <ng-container *ngIf="(task._subCount || 0) > 0">
            <div class="tmwf-kanban-card-divider"></div>
            <app-task-progress-indicator [totalCount]="task._subCount || 0" [doneCount]="task._subDone || 0"
              [showBar]="true" [compact]="true">
            </app-task-progress-indicator>
          </ng-container>

          <!-- Entity tags (Patient/Prescriber/SOC). Renders only when the API
               supplies tag objects with category_name; otherwise this is a no-op.
               TODO: Resolve tag IDs to names once a tag lookup is wired through. -->
          <div class="tmwf-card-tags" *ngIf="getEntityTags(task).length > 0">
            <span *ngFor="let tag of getEntityTags(task).slice(0, 3)" class="tmwf-entity-tag" [ngClass]="{
                'tmwf-tag-patient': (tag.category_name || '').toUpperCase() === 'PATIENT',
                'tmwf-tag-prescriber': (tag.category_name || '').toUpperCase() === 'PRESCRIBER',
                'tmwf-tag-soc': (tag.category_name || '').toUpperCase() === 'SOC'
              }">
              {{ tag.tag_name }}
            </span>
            <span *ngIf="getEntityTags(task).length > 3" class="tmwf-entity-tag tmwf-tag-more">
              +{{ getEntityTags(task).length - 3 }}
            </span>
          </div>

          <!-- Custom empty placeholder so CDK doesn't clone the card into the source slot. -->
          <div *cdkDragPlaceholder class="tmwf-drag-placeholder"></div>
        </div>

      </div>
    </div>
  </div>

  <!-- ========== TASKS TABLE VIEW ========== -->
  <div class="tmwf-grid-wrapper" *ngIf="!isLoadingTasks && currentViewMode === 'table'">
    <ag-grid-angular class="ag-theme-balham tmwf-grid" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
      [rowData]="filteredRowData" [frameworkComponents]="frameworkComponents" [rowHeight]="52" [headerHeight]="48"
      [suppressCellFocus]="true" [animateRows]="true" [masterDetail]="true" [isRowMaster]="isRowMaster"
      [detailRowAutoHeight]="true" [detailCellRendererParams]="detailCellRendererParams" [pagination]="true"
      [paginationPageSize]="paginationPageSize" [suppressPaginationPanel]="true" [domLayout]="'autoHeight'"
      [getRowId]="getRowId" [context]="{ componentParent: this }" (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)" (paginationChanged)="onPaginationChanged()">
    </ag-grid-angular>

    <!-- Custom Pagination Footer -->
    <div class="tmwf-pagination-footer">
      <div class="tmwf-pagination-left">
        <span class="tmwf-pagination-label">Rows per page</span>
        <div class="tmwf-page-size-wrapper">
          <select class="tmwf-page-size-select" [(ngModel)]="paginationPageSize"
            (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
          </select>
          <svg class="tmwf-page-size-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#999"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>
      <div class="tmwf-pagination-right">
        <button class="tmwf-page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <ng-container *ngFor="let page of visiblePages">
          <span *ngIf="page === '...'" class="tmwf-page-ellipsis">...</span>
          <button *ngIf="page !== '...'" class="tmwf-page-num" [class.tmwf-page-active]="page === currentPage + 1"
            (click)="goToPage(+page - 1)">{{ page }}</button>
        </ng-container>
        <button class="tmwf-page-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToPage(currentPage + 1)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 6 15 12 9 18"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- ========== SUBTASK SIDEBAR (slides in from right) ========== -->
  <app-subtask-drilldown-panel [isOpen]="sidebarOpen" [task]="sidebarTask" [subtasks]="sidebarSubtasks"
    [statusOptions]="statusOptions" [priorityOptions]="priorityOptions" [taskTypeOptions]="taskTypeOptions"
    [isLoadingSubtasks]="isLoadingSidebarSubtasks" [isRefreshing]="isRefreshingSidebar" (closed)="onSidebarClosed()"
    (subtaskCreated)="onSidebarSubtaskCreated($event)" (subtaskUpdated)="onSidebarSubtaskUpdated($event)"
    (subtaskStatusChanged)="onSidebarSubtaskStatusChanged($event)">
  </app-subtask-drilldown-panel>

</div>